export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14404.0341d802.jpg";